import _Avatar from "@mui/material/Avatar";
import _Skeleton from "@mui/material/Skeleton";
import { lighten } from '@mui/material/styles';
import React from 'react';
import { PersonIcon } from '../icons';
const colors = ['#2AC682', '#BB8A1A', '#528BE8', '#F36565', '#FA823E', '#DD428D', '#CF58E1', '#743AEF', '#1589BB', '#268B1D', '#846858'];
export function UserAvatar({
  size: _size,
  bgColor,
  color,
  user
}) {
  const size = _size || 32;
  if (user === undefined) return /*#__PURE__*/React.createElement(_Skeleton, {
    sx: {
      flexShrink: 0,
      height: size,
      width: size
    },
    variant: "circular"
  });
  if (user === null) return /*#__PURE__*/React.createElement(_Avatar, {
    sx: ({
      palette
    }) => ({
      bgcolor: bgColor || palette.primary.light,
      color,
      fontSize: size && typeof size === 'number' && size >= 48 ? '1.5rem' : undefined,
      fontWeight: size && typeof size === 'number' && size >= 48 ? 700 : undefined,
      height: size,
      width: size
    })
  }, /*#__PURE__*/React.createElement(PersonIcon, {
    fontSize: "small",
    sx: {
      color: '#fff'
    }
  }));
  const {
    profilePicture,
    username
  } = user;
  let firstLetter = username && String.fromCodePoint(username.codePointAt(0) || 0);
  if (firstLetter?.match(/[a-z]/i)) firstLetter = firstLetter?.toUpperCase();
  return profilePicture ? /*#__PURE__*/React.createElement(_Avatar, {
    src: profilePicture,
    sx: {
      height: size,
      width: size
    }
  }) : /*#__PURE__*/React.createElement(_Avatar, {
    sx: ({
      palette
    }) => ({
      bgcolor: bgColor || (firstLetter ? lighten(colors[firstLetter.charCodeAt(0) % colors.length], 0.8) : palette.primary.light),
      color: color || (firstLetter ? colors[firstLetter.charCodeAt(0) % colors.length] : undefined),
      fontSize: size && typeof size === 'number' && size >= 48 ? '1.5rem' : undefined,
      fontWeight: size && typeof size === 'number' && size >= 48 ? 700 : undefined,
      height: size,
      width: size
    })
  }, firstLetter || /*#__PURE__*/React.createElement(PersonIcon, {
    fontSize: "small",
    sx: {
      color: '#fff'
    }
  }));
}